export const FIELD_LABELS: Record<string, string> = {
  vermieter_id: 'Vermieter',
  adresse_id: 'Adresse',
  haus_id: 'Haus',
  einheit_id: 'Einheit',
  zustaendig_user_id: 'Zuständig',
  zustaendig_context: 'Bearbeitungs-Notiz',
  latitude: 'Breitengrad',
  longitude: 'Längengrad',
  bebauungsplan: 'Bebauungsplan',
  bplan_nr: 'B-Plan-Nr.',
  aktenzeichen: 'Aktenzeichen',
  staat: 'Bundesland',
  status: 'Status',
  state: 'Status',
  notes: 'Notizen',
  responsible_person: 'Verantwortliche Person',
  filename: 'Dateiname',
  einheit_attached: 'Einheit verknüpft',
  inserat_attached: 'Inserat verknüpft',
  inserat_detached: 'Inserat entfernt',
  address: 'Adresse',
  zipcode: 'PLZ',
  city: 'Stadt',
  strasse: 'Straße',
  hausnummer: 'Hausnummer',
  plz: 'PLZ',
  stadt: 'Stadt',
  bezeichnung: 'Bezeichnung',
  typ: 'Typ',
  name: 'Name',
  email: 'E-Mail',
  telefon: 'Telefon',
  ort: 'Ort',
  land: 'Land',
  geburtsdatum: 'Geburtsdatum',
  host_name: 'Gastgeber-Name',
  host_type: 'Gastgeber-Typ',
  address_verified: 'Adresse verifiziert',
};

export const ACTION_LABELS: Record<string, string> = {
  created: 'Erstellt',
  state_changed: 'Status geändert',
  detail_scraped: 'Aktualisierung ausgeführt',
  scrape_updated: 'Automatisch aktualisiert',
  period_override_added: 'Buchungszeitraum manuell kategorisiert',
  period_override_removed: 'Manuelle Kategorisierung entfernt',
  period_override_reset: 'Manuelle Kategorisierung zurückgesetzt',
  document_uploaded: 'Dokument hochgeladen',
  document_generated: 'Dokument generiert',
  document_updated: 'Dokument aktualisiert',
  document_deleted: 'Dokument gelöscht',
  annotation_added: 'Kommentar hinzugefügt',
  annotation_updated: 'Kommentar bearbeitet',
  annotation_deleted: 'Kommentar gelöscht',
  assigned: 'Zuständigkeit geändert',
  bplan_assigned: 'B-Plan zugeordnet',
  bplan_unassigned: 'B-Plan entfernt',
  merged: 'Zusammengeführt',
  restored: 'Wiederhergestellt',
  soft_deleted: 'Ausgeblendet',
  letter_sent: 'Brief erstellt',
  letter_draft_created: 'Brief-Entwurf erstellt',
  letter_draft_updated: 'Brief-Entwurf aktualisiert',
  letter_finalized: 'Brief versendet',
  communication_created: 'Kommunikation erfasst',
  communication_updated: 'Kommunikation aktualisiert',
  communication_logged: 'Kommunikation erfasst',
  communication_deleted: 'Kommunikation entfernt',
  letterhead_created: 'Briefkopf angelegt',
  letterhead_updated: 'Briefkopf aktualisiert',
  letterhead_deleted: 'Briefkopf gelöscht',
};

export function fieldLabel(name: string | null | undefined): string {
  if (!name) return '';
  return FIELD_LABELS[name] ?? name;
}

export function actionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action;
}
